import {
  ArrowLeftRight,
  ArrowRightToLine,
  Battery,
  Circle,
  Coins,
  Eye,
  Factory,
  Flag,
  Flame,
  Focus,
  Ghost,
  Heart,
  HeartPulse,
  Leaf,
  Lock,
  Moon,
  Package,
  Recycle,
  RotateCcw,
  Shield,
  ShieldCheck,
  ShieldPlus,
  Signal,
  Swords,
  Target,
  Trash2,
  TrendingUp,
  User,
  Users,
  Wrench,
  Zap,
} from "lucide-react"
import type { CardColor, SkillId } from "../schemas"

type IconComponent = React.ComponentType<{
  size?: number | string
  strokeWidth?: number
  className?: string
}>

export const SKILL_ICON: Record<SkillId, IconComponent> = {
  guard: Shield,
  swift: Zap,
  sneak: Ghost,
  armor: ShieldPlus,
  breakthrough: Swords,
  ranged: Target,
  repair: Wrench,
  rally: TrendingUp,
  jam: Lock,
  shift: ArrowLeftRight,
  deploy: Package,
  scrap: Trash2,
  recycle: Recycle,
  scout: Eye,
  broker: Coins,
  salvage: RotateCcw,
  charge: Battery,
  generator: Factory,
  ko: Swords,
  focus: Focus,
  coordinated_strike: Users,
  recover: HeartPulse,
  shield: ShieldCheck,
  spark: Zap,
  battery: ArrowRightToLine,
}

export const FACTION_ICON: Record<CardColor, IconComponent> = {
  colorless: Circle,
  red: Flame,
  yellow: Flag,
  green: Leaf,
  blue: Signal,
  purple: Moon,
}

/** The arrow-to-line icon representing "exhaust/tap". */
export const ExhaustIcon: IconComponent = ArrowRightToLine

/** Ally requirement icons. */
export const AllyIcon: IconComponent = User
export const DoubleAllyIcon: IconComponent = Users

/** Energy/cost icon. */
export const EnergyIcon: IconComponent = Zap

/** Attack and health icons. */
export const AttackIcon: IconComponent = Swords
export const HealthIcon: IconComponent = Heart
